import { toast } from 'react-toastify'
import type { SagaIterator } from 'redux-saga'
import { call, put, takeLatest } from 'redux-saga/effects'
import { errorTextTryingTo } from '../../helpers'

import { Punchlist } from '../../api'
import inspectionReportsActions from './actions'
import { CreateInspectionReportAction, FetchInspectionReportByIdAction, FetchInspectionReportsAction, inspectionReportsTypes } from './types'

export function *fetchInspectionReports({
  payload,
  callback,
}: FetchInspectionReportsAction): SagaIterator {
  let success = false
  try {
    const inspectionReports = yield call(
      Punchlist.inspectionRequests.getAllInspectionRequests,
      { limit: payload.limit, start: payload.start ?? 0 }
    )
    if (inspectionReports) {
      yield put(inspectionReportsActions.setInspectionReports(inspectionReports))
    }
    success = true
    if (callback) yield call(callback, success)
  } catch (error) {
    console.log({ error })
    yield call(toast.error, errorTextTryingTo('get the inspection reports'))
    if (callback) yield call(callback, false)
  }
}

export function *fetchInspectionReportById({
  payload,
  callback,
}: FetchInspectionReportByIdAction): SagaIterator {
  let success = false
  try {
    const inspectionReport = yield call(
      Punchlist.inspectionRequests.getInspectionRequestById,
      { id: payload }
    )
    yield put(inspectionReportsActions.setInspectionReportById(inspectionReport))
    success = true
    if (callback) yield call(callback, success)
  } catch (error) {
    console.log({ error })
    yield call(toast.error, errorTextTryingTo('get the inspection report'))
    if (callback) yield call(callback, false)
  }
}

export function *createInspectionReport({
  payload,
  callback,
}: CreateInspectionReportAction): SagaIterator {
  let success = false
  try {
    yield call(
      Punchlist.inspectionRequests.createInspectionRequest,
      payload
    )
    success = true
    if (callback) yield call(callback, success)
  } catch (error) {
    console.log({ error })
    yield call(toast.error, errorTextTryingTo('create the inspection report'))
    if (callback) yield call(callback, false)
  }
}

export default function *saga(): SagaIterator {
  yield takeLatest(
    inspectionReportsTypes.FETCH_INSPECTION_REPORT_BY_ID,
    fetchInspectionReportById
  )
  yield takeLatest(
    inspectionReportsTypes.FETCH_INSPECTION_REPORTS,
    fetchInspectionReports
  )
  yield takeLatest(
    inspectionReportsTypes.CREATE_INSPECTION_REPORT,
    createInspectionReport
  )
}
